<template>
  <div>

    <el-row :gutter="20">
      <el-col :span="col1">
        <el-form :inline="true">
          <el-form-item>
            <el-input v-model="queryUserDesc" size="small" placeholder="请输入查询条件" class="sx-input"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="tableData" border highlight-current-row @row-click="handleCurrentRowChange">

            <el-table-column prop="id" label="编号" v-if="false">
            </el-table-column>
            <el-table-column sortable prop="userName" label="用户名" show-overflow-tooltip header-align="center" align="center">
            </el-table-column>
            <el-table-column sortable prop="userDesc" label="姓名" show-overflow-tooltip header-align="center" align="center">
            </el-table-column>



        </el-table>
        <el-pagination small layout="total,prev, pager, next" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pageSize" :total="totalRows">
        </el-pagination>
      </el-col>

      <el-col :span="col2">
        <div class="tree-container">
          <el-tree v-loading="loadingTree" :data="dataTree" :props="defaultProps" ref='tree' node-key="id" @node-click="handleNodeClick">
          </el-tree>
        </div>
      </el-col>

      <el-col :span="col3">
        <div style="padding: 10px;">
          <span>{{selectedUserName}} {{selectedUserId}}</span>
        </div>

        <div style="padding: 10px;">
          <span>{{selectedMenuName}} {{selectedMenuId}}</span>
        </div>
        <el-radio-group v-model="radio" v-if="isShow" style="padding: 10px;">
          <el-radio :label="0" @change="radioDept">按部门</el-radio>
          <el-radio :label="1" @change="radioUser">按人</el-radio>
        </el-radio-group>
      </el-col>

    </el-row>
  </div>
</template>

<script>
  import axios from '@/axios'
  export default {

    data() {
      return {
        col1: 6,
        col2: 6,
        col3: 12,
        queryUserDesc: '',
        loading: false,
        tableData: [],
        currentPage: 1,
        totalRows: 0,
        pageSize: 15,
        pageSizes: [10, 20, 30, 40],
        loadingTree: false,
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'text',
        },
        radio: 0,
        selectedUserId: '',
        selectedUserName: '',
        selectedMenuId: '',
        selectedMenuName: '',

        isShow: false
      }
    },
    methods: {
   handleCurrentChange(val) {
     this.currentPage = val
     this.getTableData()
   },
      getTableData() {
        this.loading = true
        var url = 'framework/SysUser/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          userDesc: this.queryUserDesc
        }
        axios.get(url, param).then(response => {
          this.tableData = response.data.data.list
          this.totalRows = response.data.data.total

          this.loading = false

        });
      },
      search() {
        this.currentPage = 1
        this.getTableData()
      },
      handleCurrentRowChange(row) {
        this.selectedUserId = row.id
        this.selectedUserName = row.userDesc
        this.selectedMenuId = null
        this.selectedMenuName = null
        var url = 'framework/SysMenu/queryMenuByUserIdForUserQuery.do'
        var param = {
          userId: row.id
        }
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data
          if (response) {
            this.loadingTree = false
          } else {
            this.loadingTree = true
          }
        });
      },
      radioDept(val) {
        this.save(val)
      },
      radioUser(val) {
        this.save(val)
      },
      query() {
        if (this.selectedMenuId != null && this.selectedUserId != null) {
          var url = 'framework/SysUserQuery/query.do'
          var param = {
            userId: this.selectedUserId,
            menuId: this.selectedMenuId,
          }
          axios.post(url, param).then(response => {
            if (response.data.code == '0') {
      this.isShow = true
              this.radio = response.data.data.queryFlag
               this.radio = parseInt(response.data.data.queryFlag)

            } else {
              this.$message({
                type: 'error',
                message: '查询失败' + response.data.msg,
              });
            }

          });


        }
      },
      save(val) {
        var url = 'framework/SysUserQuery/save.do'
        var param = {
          userId: this.selectedUserId,
          menuId: this.selectedMenuId,
          queryFlag: val
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
          } else {
            this.$message({
              type: 'error',
              message: '修改失败' + response.data.msg,
            });
          }
        });

      },
      handleNodeClick(data) {
        this.selectedMenuId = data.id
        this.selectedMenuName = data.text

        this.query()
      }
    }

  }
</script>
<!-- select distinct case ( select  nvl(query_flag,'0')  from SYS_QUERY where   user_id = '3')
  when '0' then  t.user_id  else '3' end from sys_user_department t
  where t.dept_id in (select m.dept_id from sys_user_department m  where    m.user_id = '3'  )  -->
<style>
</style>



// WEBPACK FOOTER //
// src/view/system/userquery.vue